module.exports = __webpack_public_path__ + "static/img/user.8aa6540.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user.jpg
// module id = ZJ6t
// module chunks = 13